import { motion } from "framer-motion";
import { Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";

const mandamientos = [
  {
    title: "Tu negocio tiene el tamaño exacto de tus estándares.",
    body: "El líder es quien establece el techo de la empresa. Si tolerás clientes que regatean, operar desde el miedo o esconderte detrás de la operación, tendrás un negocio barato. Subí tus estándares personales y el mercado subirá su respeto hacia vos.",
  },
  {
    title: 'No pagarás el "Impuesto a la Invisibilidad".',
    body: "Ser el mejor en tu rubro pero mantenerlo en secreto no es humildad, es una fuga de capital directa. Si no comunicás tu autoridad y tu prestigio, le estás financiando el crecimiento a tu competencia.",
  },
  {
    title: "Construirás Arquitectura antes que Estética.",
    body: "Un logo bonito o un Instagram prolijo no salvan a un mal negocio ni elevan precios. Antes de diseñar, debés estructurar el posicionamiento, la oferta y el modelo de valor de tu marca. La claridad estratégica vence al ingenio táctico.",
  },
  {
    title: "Cobrarás por la transformación, no por tus horas.",
    body: "El Alto Valor (High Ticket) no se justifica por el tiempo ni el esfuerzo que invertís, sino por la magnitud del problema que resolvés y la brecha que cerrás para tu cliente. Tu trayectoria es el atajo de tu cliente; cobrá por ello.",
  },
  {
    title: 'Destruirás el techo del "Boca en Boca".',
    body: "Las recomendaciones te trajeron hasta acá y te dieron estabilidad, pero no te llevarán al siguiente nivel. Necesitás un sistema predecible donde tu reputación haga la venta mucho antes de que el cliente llegue a la reunión.",
  },
  {
    title: "Usarás tu precio como tu mejor filtro.",
    body: "Quien compite por precio, muere por precio. Al elevar tus tarifas, no solo aumentás tus márgenes de ganancia, sino que alejás automáticamente a los clientes problemáticos y atraés a los que verdaderamente respetan tu expertis.",
  },
  {
    title: "Demostrarás que la Prueba siempre supera a la Promesa.",
    body: "El mercado de Alto Valor está cansado de promesas vacías. Tu autoridad debe construirse sobre resultados tangibles. No prometas que sos el mejor: exhibí los casos de éxito, los números y las transformaciones que demuestran que lo sos.",
  },
  {
    title: "Renunciarás a venderle a todo el mundo.",
    body: "Si le decís que sí a cualquiera que tenga dinero, en realidad le estás diciendo que no al crecimiento estructural de tu empresa. La autoridad existe en la exclusividad. Especializate, cerrá tu enfoque y dominarás tu nicho.",
  },
  {
    title: "Documentarás tu grandeza (No inventarás contenido).",
    body: "Un líder no necesita hacer bailes ni seguir tendencias vacías para tener visibilidad. Tu única tarea de marketing es hacer cosas épicas en tu negocio y luego hablar de ellas. Mostrá tus victorias, tus procesos y tu visión.",
  },
  {
    title: "Dejarás de operar para empezar a comandar.",
    body: "Tu rol como CEO no es apagar incendios diarios, es dictar la dirección estratégica de la empresa. Solo cuando salís de las sombras y de la trampa operativa, tu marca deja de ser un emprendimiento y se convierte en un legado institucional.",
  },
];

const Mandamientos = () => {
  const scrollToCalendly = () => {
    const el = document.getElementById("calendly");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      {/* Hero */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 bg-[#470628] overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#470628] via-[#600832] to-[#470628]" />
        <div className="container px-4 relative z-10 text-center">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="inline-block text-[#FF9FBD] text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase mb-6"
          >
            Coressen Global
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6"
          >
            Los 10 Mandamientos{" "}
            <span className="text-[#FF9FBD]">Estratégicos</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="text-white/70 text-lg md:text-xl max-w-2xl mx-auto"
          >
            Para Escalar tu Autoridad y Cobrar tu Verdadero Valor
          </motion.p>
        </div>
      </section>

      {/* Mandamientos List */}
      <section id="mandamientos" className="py-16 md:py-24 bg-background">
        <div className="container px-4 max-w-3xl mx-auto">
          {mandamientos.map((m, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="mb-12 last:mb-0"
            >
              <div className="flex items-start gap-4 sm:gap-5">
                {/* Number */}
                <span className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary flex items-center justify-center text-primary-foreground font-bold text-sm sm:text-base">
                  {i + 1}
                </span>
                <div>
                  <h3 className="font-display text-lg sm:text-xl md:text-2xl font-bold text-foreground mb-2 leading-snug">
                    {m.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed text-sm sm:text-base">
                    {m.body}
                  </p>
                </div>
              </div>
              {i < mandamientos.length - 1 && (
                <div className="mt-8 ml-5 sm:ml-6 w-px h-8 bg-border" />
              )}
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-28 bg-[#470628] relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#470628] to-[#600832]" />
        <div className="container px-4 relative z-10 text-center max-w-2xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-6 leading-tight"
          >
            El Siguiente Paso
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-white/80 text-base sm:text-lg leading-relaxed mb-4"
          >
            Leer estos mandamientos es fácil. Aplicarlos cuando estás inmerso en la operación diaria de tu negocio, es el verdadero desafío.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="text-white/70 text-base sm:text-lg leading-relaxed mb-8"
          >
            Si liderás una empresa con trayectoria y estás listo para dejar de competir por precio y convertir tu marca en la Autoridad N°1 de tu mercado, este es el momento de actuar.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <Button
              variant="gold"
              size="xl"
              onClick={scrollToCalendly}
              className="text-base sm:text-lg px-8 sm:px-12"
            >
              <Calendar className="w-5 h-5 mr-2" />
              AGENDAR LLAMADA DE CLARIDAD
            </Button>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Mandamientos;
